import { Package } from './package.interface';
import { Product } from './product.interface';

export interface Day {
  id?: number;
  festival_id?: number;
  lodge_id?: number;
  date?: string;
  daytype?: DayTypeType;
  time_from?: string;
  time_to?: string;
  time_latest?: string;
  status: DayStatusType;
  products?: Product[];
  packages?: Package[];
}

export type DayTypeType = 'morning' | 'evening';
export const DayTypeTypeMapper: Record<DayTypeType, string> = {
  morning: 'Mittags',
  evening: 'Abends',
};

export type DayStatusType =
  | 'avail'
  | 'partly'
  | 'unavail'
  | 'nonbookable'
  | 'oninquiry';

export const DayStatusTypeMapper: Record<DayStatusType, string> = {
  avail: 'Verfügbar',
  partly: 'Restplätze',
  unavail: 'Ausgebucht',
  nonbookable: 'Nicht buchbar',
  oninquiry: 'Auf Anfrage',
};

export const DayStatusColorMapper: Record<DayStatusType, string> = {
  avail: 'success',
  partly: 'info',
  unavail: 'danger',
  nonbookable: 'warning',
  oninquiry: 'secondary',
};
